<script>
import { mapState, mapActions } from 'vuex';
import ModalOverlay from '@/components/modal/ModalOverlay';
import Footer from '@/components/Footer';
import Menu from '@/components/Menu';

export default {
  name: 'ModalMenu',
  components: {
    ModalOverlay,
    Menu,
    Footer,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['']),
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions(['toggleModalMenu']),
  },
};
</script>

<template>
  <div>
    <ModalOverlay>
      <div class="menu-modal">
        <div class="menu-modal__close">
          <div class="close" @click="toggleModalMenu(false)">
            <img :src="require('@/assets/svg/close.svg')" />
          </div>
        </div>
        <div class="menu-modal__content">
          <Menu :modal="true"></Menu>
          <Footer :modal="true"></Footer>
        </div>
      </div>
    </ModalOverlay>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.close {
  padding: 20px 15px 15px;
  display: inline-block;

  img {
    width: 16px;
    height: 16px;
    display: flex;
  }
}

.menu-modal {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;

  &__close {
    flex-shrink: 0;
  }

  &__content {
    background: #131717;
    width: 100%;
    max-width: 340px;
    height: 100vh;
    overflow-y: auto;
  }
}
</style>
